import axios from 'axios';

// Function to get API URL (called when needed)
const getApiUrl = () => {
  console.log('Getting API URL...');
  console.log('Config:', window.__APP_CONFIG__);

  // Config should be loaded by now
  if (window.__APP_CONFIG__?.apiUrl) {
    console.log('Using config API URL:', window.__APP_CONFIG__.apiUrl);
    return window.__APP_CONFIG__.apiUrl;
  }

  // Fallback
  console.warn('No config found, using hardcoded fallback');
  return 'https://localhost:5001';
};

// LAZY: Don't create axios instance immediately
let apiInstance = null;

// Function to get or create API instance
const getApiInstance = () => {
  if (!apiInstance) {
    console.log('Creating API instance...');

    apiInstance = axios.create({
      baseURL: getApiUrl(), // This now runs when actually needed
      timeout: 15000,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Add interceptors
    apiInstance.interceptors.request.use(config => {
      console.log(`${config.method?.toUpperCase()} ${config.url}`);
      return config;
    });

    apiInstance.interceptors.response.use(
      response => {
        console.log(`${response.status} ${response.config.url}`);
        return response;
      },
      error => {
        if (error.response) {
          console.error(`${error.response.status} ${error.config.url}:`, error.response.data);
        } else {
          console.error('Network Error:', error.message);
        }
        return Promise.reject(error);
      }
    );

    console.log('API service created:');
    console.log('Base URL:', apiInstance.defaults.baseURL);
    console.log('Environment:', window.__APP_CONFIG__?.environment || 'unknown');
  }
  
  return apiInstance;
};

// Export a proxy object that creates the instance when accessed
export const api = {
  get: (...args) => getApiInstance().get(...args),
  post: (...args) => getApiInstance().post(...args),
  put: (...args) => getApiInstance().put(...args),
  patch: (...args) => getApiInstance().patch(...args),
  delete: (...args) => getApiInstance().delete(...args),
  request: (...args) => getApiInstance().request(...args),
 
  
  // ✅ Access to the actual instance if needed
  getInstance: () => getApiInstance(),
  
  // ✅ Access to defaults
  get defaults() {
    return getApiInstance().defaults;
  }
};

export default api;